export default __webpack_public_path__ + "static/media/HotBadge.6610e721.svg";